import { LicenseIcon } from '@hugeicons/react'

import { Button } from '@/shared/ui/Button'

import { useLevelContext } from '../../../context'

export const DigitalProductJourneyLevelPlayChallengeFooterIntroButton = () => {
  const { goToPrevStep } = useLevelContext()

  return (
    <Button
      variant="ghost"
      icon
      aria-label="Ver introdução"
      className="shrink-0"
      leadingIcon={<LicenseIcon size={20} variant="duotone" />}
      onClick={goToPrevStep}
    />
  )
}
